import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import {push, replace} from 'svelte-spa-router';
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyCN_JnO6-Xn_q5wgCj9ji7KlpJZUpU_K6Y",
  authDomain: "sms-system-853de.firebaseapp.com",
  projectId: "sms-system-853de",
  storageBucket: "sms-system-853de.appspot.com",
  messagingSenderId: "556135900717",
  appId: "1:556135900717:web:d831287fe1fd6bf8197aa4",
  measurementId: "G-M5KZF3NJ3D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);

export function signIn(auth, email, password) {
    signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
        // Signed in 
        // const user = userCredential.user;
        // rout to dash
        push('/dashboard');
    })
    .catch((error) => {
        // const errorCode = error.code;
        const errorMessage = error.message;
        alert(errorMessage);
    });
}

export function passwordReset(auth) {
    var email = prompt("Please enter your email address:");
    sendPasswordResetEmail(auth, email)
    .then(() => {
        // Password reset email sent!
        // ..
        alert("Password reset email sent!");
    })
    .catch((error) => {
        //const errorCode = error.code;
        const errorMessage = error.message;
        // ..
        alert(errorMessage);
    });
}

export const analytics = getAnalytics(app);